import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import useMediaQuery from '@web-ui-kit/hooks.use-media-query'
import BannerEdubookApp from '../BannerEdubookApp'
import * as Sc from '../../App.style'
import { ROUTES } from 'routes/paths'
import Navigation from 'components/Navigation'
import SubHeader from 'components/SubHeader'
import Header from 'components/Header'
import Footer from 'components/Footer'
import { NAVIGATION_TYPES } from 'utils/constants'
import Survey from 'components/Survey'
import { getCurrentUserTypeByRole } from 'utils'
import { useGetUser } from 'hooks/user'
import useCheckCanary from 'hooks/useCheckCanary'
import { STATUS_FLAGS } from 'utils/constants/flags'

const WrapperLayout = ({ children }) => {
  const { pathname } = useLocation()
  const { data: userData } = useGetUser()
  const { footer, fullScreen, fullWidthGrid } = useSelector(
    ({ drawer }) => drawer
  )
  const { isLarge, isSmall } = useMediaQuery()
  const { isTeacher } = getCurrentUserTypeByRole(userData?.role)
  const {
    displayNavHeader,
    optionsNavHeader: {
      backward,
      id: navHeaderId,
      infoItem,
      isDemo,
      isLoading: isLoadingNavHeader,
      navButton,
      sections,
      select,
      tag,
      title: navTitle,
    },
  } = useSelector(({ header }) => header)

  const displaySatisfactionSurvey =
    useCheckCanary(
      window?.satisfactionSurvey?.canaryUsers,
      window?.satisfactionSurvey?.enableSatisfactionSurvey
    ) &&
    isTeacher &&
    userData?.userFlags?.FEEDBACK_POOL === STATUS_FLAGS.TRUE &&
    userData?.userFlags?.FORCE_RESET_PASSWORD === STATUS_FLAGS.FALSE

  const renderBannerEdubook = () => {
    if (!isLarge) return <BannerEdubookApp />
    return null
  }

  if (
    pathname === ROUTES.EDUBOOK_LEGAL_CONDITIONS ||
    pathname === ROUTES.PUBLISHER_LEGAL_CONDITIONS
  ) {
    return children
  }
  const isTablet = isSmall && !isLarge
  return (
    <>
      <Sc.Layout $fullScreen={fullScreen} $showSidebar={!fullScreen}>
        {renderBannerEdubook()}
        {!fullScreen && isLarge && <Navigation />}
        {displayNavHeader ? (
          <SubHeader
            backward={backward}
            button={navButton}
            id={navHeaderId}
            infoItem={infoItem}
            isDemo={isDemo}
            isLoading={isLoadingNavHeader}
            sections={sections}
            select={select}
            tag={tag}
            title={navTitle}
          />
        ) : (
          !fullScreen && <Header />
        )}
        <Sc.MainContainer
          $isFullScreen={fullScreen}
          $isFullWidth={fullWidthGrid}
        >
          {children}
        </Sc.MainContainer>
        {footer.enabled && <Footer>{footer.children}</Footer>}
        {!fullScreen && isTablet && (
          <Navigation type={NAVIGATION_TYPES.BOTTOM} />
        )}
      </Sc.Layout>
      {displaySatisfactionSurvey && <Survey />}
    </>
  )
}

WrapperLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default WrapperLayout
